import React, { FC } from 'react';
import { ClickableDivComponent } from './types';

export const ClickableDiv: FC<ClickableDivComponent> = (
  {
    onClick, children, className, disabled = false,
  },
) => (
  <div
    className={className}
    data-disabled={disabled}
    role="button"
    tabIndex={0}
    onClick={() => {
      if (!disabled) {
        onClick();
      }
    }}
    onKeyDown={() => false}
  >
    {children}
  </div>
);
